import React, { useState, useEffect } from "react";
import { useDataContext } from "./contexts/DataProvider";

const Slideshow = () => {
  const { mainboard } = useDataContext();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Filter active slides and sort by display order
  const slides = (mainboard || [])
    .filter((item) => item.isActive !== false)
    .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));

  // Auto-advance slideshow
  useEffect(() => {
    if (slides.length <= 1) return;

    const currentSlide = slides[currentIndex];
    const duration = (currentSlide?.duration || 10) * 1000;

    const timer = setTimeout(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % slides.length);
        setIsTransitioning(false);
      }, 500);
    }, duration);

    return () => clearTimeout(timer);
  }, [currentIndex, slides]);

  // Reset index if slides change
  useEffect(() => {
    if (currentIndex >= slides.length) {
      setCurrentIndex(0);
    }
  }, [slides.length, currentIndex]);

  const currentSlide = slides[currentIndex];
  const isImageSlide = currentSlide?.displayType === 'image' && currentSlide?.imageUrl;

  if (!slides.length) {
    return (
      <div style={styles.container}>
        <div style={styles.emptyState}>
          <span style={styles.emptyIcon}>☬</span>
          <h2 style={styles.emptyTitle}>ਵਾਹਿਗੁਰੂ ਜੀ ਕਾ ਖਾਲਸਾ</h2>
          <h2 style={styles.emptyTitle}>ਵਾਹਿਗੁਰੂ ਜੀ ਕੀ ਫਤਹਿ</h2>
          <p style={styles.emptyText}>No announcements at this time</p>
        </div>
      </div>
    );
  }

  // Image Slide
  if (isImageSlide) {
    return (
      <div style={styles.imageContainer}>
        <img
          src={currentSlide.imageUrl}
          alt={currentSlide.title}
          style={{
            ...styles.fullImage,
            opacity: isTransitioning ? 0 : 1,
          }}
        />

      </div>
    );
  }

  // Text Slide
  return (
    <div style={styles.container}>
      {/* Title - Fixed at Top on the line */}
      <div
        style={{
          ...styles.titleContainer,
          opacity: isTransitioning ? 0 : 1,
          transform: isTransitioning ? "translateY(-20px)" : "translateY(0)",
        }}
      >
        {currentSlide?.title && (
          <h1 style={styles.title}>{currentSlide.title}</h1>
        )}
      </div>

      {/* Content - Center */}
      <div
        style={{
          ...styles.contentContainer,
          opacity: isTransitioning ? 0 : 1,
          transform: isTransitioning ? "translateY(20px)" : "translateY(0)",
        }}
      >
        {currentSlide?.content && (
          <p style={styles.content}>{currentSlide.content}</p>
        )}
      </div>

    </div>
  );
};

const styles = {
  container: {
    width: "100vw",
    height: "100vh",
    backgroundImage: "url('/custom/bg.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
  },
  imageContainer: {
    width: "100vw",
    height: "100vh",
    backgroundColor: "#000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
  },
  fullImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    transition: "opacity 0.5s ease-in-out",
  },
  titleContainer: {
    position: "absolute",
    top: "80px",
    left: 0,
    right: 0,
    textAlign: "center",
    padding: "0 40px",
    transition: "all 0.5s ease-in-out",
  },
  title: {
    fontSize: "5rem",
    fontWeight: "800",
    color: "#800020",
    margin: 0,
    textShadow: "0 2px 8px rgba(0,0,0,0.2)",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    lineHeight: "1.2",
    letterSpacing: "2px",
  },
  contentContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "180px 60px 100px 60px",
    transition: "all 0.5s ease-in-out",
  },
  content: {
    fontSize: "3rem",
    fontWeight: "600",
    color: "#1a237e",
    margin: 0,
    textShadow: "0 2px 8px rgba(0,0,0,0.1)",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    lineHeight: "1.6",
    textAlign: "center",
    maxWidth: "90%",
    whiteSpace: "pre-line",
  },
  emptyState: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "#fff",
  },
  emptyIcon: {
    fontSize: "6rem",
    display: "block",
    marginBottom: "24px",
    color: "#FFD700",
    textShadow: "0 0 30px rgba(255,215,0,0.5)",
  },
  emptyTitle: {
    fontSize: "3rem",
    fontWeight: "700",
    margin: "8px 0",
    color: "#FFD700",
    textShadow: "0 4px 20px rgba(0,0,0,0.5)",
    fontFamily: "'Noto Sans Gurmukhi', 'Segoe UI', Arial, sans-serif",
  },
  emptyText: {
    fontSize: "1.5rem",
    color: "rgba(255,255,255,0.8)",
    marginTop: "24px",
  },
};

export default Slideshow;
